<template>
  <div id="features" class="features container">
    <div class="features-heading">
      <h1>FEATURES</h1>
    </div>
    <div class="features-content">
      <div class="feature">
        <div class="feature-text">
          <h2>See the Big Picture</h2>
          <p>
            The high performance Traitz tool is designed to give you a macro
            view of your entire collection so you can see the big picture and
            shape it to your artistic vision.
          </p>
        </div>
        <div class="feature-image">
          <video autoplay loop muted playsinline>
            <source src="@/assets/features-1.mp4" />
          </video>
        </div>
      </div>
      <div class="feature">
        <div class="feature-image">
          <img src="@/assets/features-2-copy.png" />
        </div>
        <div class="feature-text">
          <h2>Craft your Collection</h2>
          <p class="primary-body">
            Traitz tool allows you to craft your Collection with precision and
            flexibility, so you can generate art in the order of 1000s, 100s or
            hone on a single artwork and make it extra special and rare.
          </p>
        </div>
      </div>
      <div class="feature">
        <div class="feature-text">
          <h2>Built on Chrome</h2>
          <p>
            Run the Traitz tool anywhere using the Google Chrome browser and
            save your progress to your computer as you go.
          </p>
        </div>
        <div class="feature-image">
          <img src="@/assets/chrome.gif" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Features",
};
</script>

<style lang="scss" scoped>
@import "@/styles/styles.scss";

.features {
  margin-bottom: 75px;
    @include media(">tablet") {
  margin-bottom: 150px;

    }
  &-heading {
    padding: 75px 0 75px 0;
    @include media(">tablet") {
      padding: 150px 0 75px 0;
      // padding-left: 2em;
      margin-left: -25px;
    }
    h1 {
      border-left: 1px solid #fff;
      padding-left: 20px;
    }
  }
  &-content {
    .feature {
      position: relative;
      display: flex;
      flex-direction: column;
      margin-bottom: 50px;
      @include media(">=desktop") {
        flex-direction: row;
        align-items: center;
        margin-bottom: 100px;
      }
      &-image {
        flex-basis: 50%;
        justify-content: center;
        align-items: center;
        display: flex;
        img,
        video {
          max-width: 740px;
          width: 100%;
        }
      }
      &-text {
        flex-basis: 50%;
        p {
          margin: 50px 0;
        }
      }
    }
    .feature:first-child {
      p {
        margin-bottom: 0;
        @include media('>=tablet') {
          margin-bottom: 100px;
        }
      }
    }
    .feature:first-child,
    .feature:nth-child(3) {
      @include media(">=tablet") {
        .feature-text {
          padding-right: 20px;
        }
        .feature-image {
          padding-left: 20px;
        }
      }
    }
    .feature:nth-child(3) {
      img {
        max-width: 220px;
        @include media('>=tablet') {
          max-width: 280px;
        }
        // width: 80%;
      }
    }
    .feature:nth-child(2) {
      @include media(">=tablet") {
        .feature-text {
          padding-left: 20px;
        }
        .feature-image {
          padding-right: 20px;
        }
      }
      img {
        margin-bottom: 50px;
        // padding-right: 0px;
        @include media(">=tablet") {
          // padding-right: 50px;
        }
      }
    }

    .feature:nth-child(2) {
      flex-direction: column-reverse;
      @include media(">=desktop") {
        flex-direction: row;
      }
    }

    .feature:nth-child(1):after {
      content: "";
      border: 1px solid rgba(255, 255, 255, 0.2);
      width: 100%;
      position: absolute;
      bottom: 0;
      right: 0;
      @include media(">=desktop") {
        width: 48%;
        bottom: -25px;
      }
    }
    .feature:nth-child(2):after {
      content: "";
      border: 1px solid rgba(255, 255, 255, 0.2);
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      @include media(">=desktop") {
        width: 48%;
        bottom: -25px;
      }
    }
  }
}
</style>
